<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <PolicyForm
      :form="form"
      @submit="submit"
      @modality="changeToModality"
      v-if="currentView == 'form'"
      @cancel="cancelForm"
      @options="fetchOptionsPolicy"
      :options-policy="optionsPolicy"
    />
    <ListModalityAndSubModality v-else :form="form" @return="changeToForm" />
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPage"
      title="APÓLICE CRIADA"
      text="Apólice criada com sucesso."
    />
    <ModalCancelInsurance
      @close="closeModal"
      v-model="modalCancel"
      title="CANCELAR APÓLICE"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import PolicyForm from "../components/PolicyForm";
import ListModalityAndSubModality from "../components/ListModalityAndSubModality";
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import PolicyMixin from "@/mixins/PolicyMixin";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import ModalCancelInsurance from "../../insurance_company/components/ModalCancelInsurance";
import FormMixin from "@/mixins/FormMixin";
export default {
  beforeRouteLeave(to, from, next) {
    this.modalCancel = true;
    this.nextRoute = to;
    if (this.cancel || this.formIsPristineCommon(this.form, this.cloneForm))
      next();
  },
  data: () => ({
    form: {
      apolice: [],
      modalidade: {},
      submodalidade: {},
      boletos: [],
      tomador: {
        razao_social: null,
        grupo: {
          nome: null
        }
      },
      cosseguros: [],
      segurado: {
        endereco: {}
      },
      processo: {
        segmento: {
          id: "justica_trabalho"
        },
        tipo_processo: {
          nome: null
        },
        tribunal: {
          nome: null
        },
        unidade: {
          nome: null
        }
      },
      parcelas: [],
      prorrogar_vigencia: false,
      escritorio: null,
      situacao: {}
    },
    currentView: "form",
    breadcrumb: [
      {
        text: "Nova Apólice",
        to: "policy"
      }
    ],
    modal: false,
    modalCancel: false,
    nextRoute: null,
    cancel: false,
    cloneForm: {
      apolice: [],
      modalidade: {},
      submodalidade: {},
      boletos: [],
      tomador: {
        razao_social: null,
        grupo: {
          nome: null
        }
      },
      cosseguros: [],
      segurado: {
        tipo_pessoa: null,
        endereco: {}
      },
      processo: {
        segmento: {
          id: "justica_trabalho"
        },
        tipo_processo: {
          nome: null
        },
        tribunal: {
          nome: null
        },
        unidade: {
          nome: null
        },
        nome_unidade: null,
        nome_tribunal: null
      },
      parcelas: [],
      prorrogar_vigencia: false,
      valor_importancia_segurada: 0,
      valor_premio: 0,
      escritorio: null
    },
    optionsPolicy: null
  }),
  mixins: [LoadingRequest, PolicyMixin, FormMixin],
  created() {
    this.fetchItems();
  },
  components: {
    PolicyForm,
    ListModalityAndSubModality,
    ModalGenericCriticism,
    ModalCancelInsurance
  },
  methods: {
    ...mapActions("policy", [
      "requestListInsuranceCompany",
      "requestListSituation",
      "requestListEmission",
      "requestNewPolicy",
      "requestOptionsPolicy"
    ]),
    ...mapActions("quotation", ["requestInsuranceCompanyQuotation"]),
    ...mapActions("insuranceCompany", ["requestPaymentMethods"]),
    fetchItems() {
      this.withLoading(
        Promise.all([
          this.requestListSituation(),
          this.requestListEmission(),
          this.requestListInsuranceCompany(),
          this.requestPaymentMethods(),
          this.requestInsuranceCompanyQuotation()
        ])
      );
    },
    async submit(form) {
      this.withLoading(
        this.requestNewPolicy(
          await this.getPayloadPolicy(form, this.optionsPolicy)
        ).then(() => {
          this.modal = true;
        })
      );
    },
    previousPage() {
      this.modal = false;
      if (this.currentView == "form") {
        this.cancel = true;
        this.$router.push({ name: "policy" });
      } else {
        this.changeToForm();
      }
    },
    changeToModality() {
      this.currentView = "modality";
      this.breadcrumb = [
        {
          text: "Alterar Modalidade",
          to: "policy"
        }
      ];
    },
    changeToForm() {
      this.currentView = "form";
      this.breadcrumb = [
        {
          text: "Nova Apólice",
          to: "policy"
        }
      ];
    },
    cancelForm() {
      this.$router.push({ name: "policy" });
    },
    closeModal(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({ name: this.nextRoute.name });
      }
    },
    fetchOptionsPolicy() {
      this.withLoading(
        this.requestOptionsPolicy(this.form.submodalidade.id).then(data => {
          this.optionsPolicy = data;
        })
      );
    }
  },
  watch: {
    "form.submodalidade"(newValue, oldValue) {
      if (!newValue || newValue == oldValue || !newValue?.id) return;
      this.fetchOptionsPolicy();
    }
  }
};
</script>
